import type { RefObject } from 'react';
import {
  useRef,
  useState,
  useEffect,
} from 'react';

function useHover<T extends HTMLElement>(): [RefObject<T | null>, boolean] {
  const [value, setValue] = useState(false);

  const ref = useRef<T>(null);

  const handleMouseOver = () => {
    setValue(true);
  };
  const handleMouseOut = () => {
    setValue(false);
  };

  useEffect(
    () => {
      const node = ref.current;
      if (node) {
        node.addEventListener('mouseover', handleMouseOver);
        node.addEventListener('mouseleave', handleMouseOut);

        return () => {
          node.removeEventListener('mouseover', handleMouseOver);
          node.removeEventListener('mouseleave', handleMouseOut);
        };
      }
      return () => {};
    },
  );

  return [ref, value];
}

export default useHover;
